import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import path from "../../routes/path";
import './ProfileHeader.scss';
const qs = require('query-string');

const ProfileHeader = (props) => {
    const {t} = useTranslation();
    const parsed = qs.parse(window.location.search);
    const foundRole = useSelector((state)=>state.userReducer.currentRole);
    const [currentRole,setCurrentRole] = useState(foundRole);
    const [type, setType] = useState('')
    const navigate = useNavigate();
    useEffect(() => {
        setCurrentRole(foundRole);
    }, [foundRole]);

    useEffect(() => {
        setType(window.location.pathname.split('/')[2])
    }, [navigate])

    const path2 = path.instructor_live_sessions_path.split('/')[2];
    const activePath = path2 === type?"active":"";


    return(
        <div className={props.profileMenuOpen?"profile-header active":"profile-header"}>
            <div onClick={()=>props.setProfileMenuOpen(!props.profileMenuOpen)} className="mobile-toggle-menu-close">
                <i className={"bi bi-x-lg"} />
            </div>
            {
                window.location.pathname === path.view_public_profile || window.location.pathname === path.public_profile_courses ? (
                    <ul>
                        <li><NavLink to={`${process.env.PUBLIC_URL}${path.view_public_profile}?id=${parsed.id}`} onClick={()=>props.setProfileMenuOpen(false)} >{t('profile_header.view_profile')}</NavLink></li>
                        <li><NavLink to={`${process.env.PUBLIC_URL}${path.public_profile_courses}?page=1&id=${parsed.id}`} onClick={()=>props.setProfileMenuOpen(false)} >{t('profile_header.courses')}</NavLink></li>

                    </ul>
                ) : (
                    <ul>
                        <li><NavLink to={`${process.env.PUBLIC_URL}${path.dashboard}`} onClick={()=>props.setProfileMenuOpen(false)} >{t('profile_header.dashboard')}</NavLink></li>
                        <li><NavLink to={`${process.env.PUBLIC_URL}${path.view_profile}`} onClick={()=>props.setProfileMenuOpen(false)} >{t('profile_header.view_profile')}</NavLink></li>
                        {currentRole==="Student"?
                            <>
                            <li><NavLink to={`${process.env.PUBLIC_URL}${path.view_profile_course}?page=1`} onClick={()=>props.setProfileMenuOpen(false)} > {t('profile_header.my_courses')}</NavLink></li>
                            {/* {currentRole==="Instructor" && <li><NavLink className={activePath} to={window.location.pathname === path.instructor_live_sessions_path?path.instructor_live_sessions_path:path.instructor_live_sessions+'?page=1'} onClick={()=>props.setProfileMenuOpen(false)} > {t('profile_header.my_sessions')}</NavLink></li>} */}
                            {/* {currentRole==="Student" && <li><NavLink className={activePath} to={window.location.pathname === path.student_live_sessions?path.student_live_sessions:path.student_live_sessions+'?page=1'} onClick={()=>props.setProfileMenuOpen(false)} > {t('profile_header.my_sessions')}</NavLink></li>} */}
                            </>
                            :
                            <>
                                <li><NavLink to={`${process.env.PUBLIC_URL}${path.view_instructor_course}?page=1`} onClick={()=>props.setProfileMenuOpen(false)} > {t('profile_header.own_course')}</NavLink></li>
                                {/* <li><NavLink className={activePath} to={window.location.pathname === path.instructor_live_sessions_path?path.instructor_live_sessions_path:path.instructor_live_sessions+'?page=1'} onClick={()=>props.setProfileMenuOpen(false)} > {t('profile_header.live_sessions')}</NavLink></li> */}
                            </>

                        }
                        <li><NavLink to={`${process.env.PUBLIC_URL}${path.wishlist}?page=1`} onClick={()=>props.setProfileMenuOpen(false)} > {t('profile_header.wishlist')}</NavLink></li>
                        <li><NavLink to={`${process.env.PUBLIC_URL}${path.profile_setting}`} onClick={()=>props.setProfileMenuOpen(false)} > {t('profile_header.setting')}</NavLink></li>
                        <li><NavLink to={`${process.env.PUBLIC_URL}${path.payment_history}?page=1`} onClick={()=>props.setProfileMenuOpen(false)} > {t('profile_header.payment_history')}</NavLink></li>
                    </ul>
                )
            }
        </div>
    )
}
export default ProfileHeader;